const authTokenKey = "authtoken";
const currentEmployeeKey = "currentEmployee";
const deviceKey = "deviceKey";

export default class LocalStorageService {
  getCurrentEmployee() {
    return JSON.parse(window.localStorage.getItem(currentEmployeeKey));
  }
  setCurrentEmployee(employee) {
    window.localStorage.setItem(currentEmployeeKey, JSON.stringify(employee));
  }
  setDeviceId(deviceId) {
    window.localStorage.setItem(deviceKey, deviceId);
  }
  getDeviceId() {
    return window.localStorage.getItem(deviceKey);
  }
  setAuthToken(token) {
    window.localStorage.setItem(authTokenKey, token);
  }
  getAuthToken() {
    return window.localStorage.getItem(authTokenKey);
  }
  clear() {
    window.localStorage.clear();
  }
}
